import React, {Component, createRef} from "react";
import { Routes, Route, Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

import AuthService from "./services/auth.service";

import Login from "./components/login.component";
import Register from "./components/register.component";
import Home from "./components/home.component";
import Profile from "./components/profile.component";
import BoardUser from "./components/board-user.component";
import BoardModerator from "./components/board-moderator.component";
import BoardAdmin from "./components/board-admin.component";

// import AuthVerify from "./common/auth-verify";
import EventBus from "./common/EventBus";
import ForgotPassword from "./components/forgot-password.component";
import ResetPassword from "./components/reset-password.component";

class App extends Component {
  constructor(props) {
    super(props);
    this.logOut = this.logOut.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.getInitials = this.getInitials.bind(this);

    this.state = {
      showModeratorBoard: false,
      showAdminBoard: false,
      currentUser: undefined,
      isDropdownOpen: false,
    };

    this.dropdownRef = createRef();
  }

  componentDidMount() {
    const user = AuthService.getCurrentUser();

    if (user) {
      this.setState({
        currentUser: user,
        showModeratorBoard: true,
      });
    }
    
    EventBus.on("logout", () => {
      this.logOut();
    });
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    EventBus.remove("logout");
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  logOut() {
    AuthService.logout();
    this.setState({
      showModeratorBoard: false,
      showAdminBoard: false,
      currentUser: undefined,
      isDropdownOpen: false,
    });
    window.location.href = "/login";
  }

  toggleDropdown() {
    this.setState({
      isDropdownOpen: !this.state.isDropdownOpen,
    })
  }

  handleClickOutside = (event) => {
    if (
        this.dropdownRef.current &&
        !this.dropdownRef.current.contains(event.target)
    ) {
      this.setState({ isDropdownOpen: false });
    }
  };

  getInitials = (firstName, lastName) => {
    const firstInitial = firstName.charAt(0).toUpperCase();
    const lastInitial = lastName.charAt(0).toUpperCase();
    return `${firstInitial}${lastInitial}`;
  };

  render() {
    const { currentUser, showModeratorBoard, isDropdownOpen } = this.state;

    return (
      <div>
        <nav className="navbar navbar-expand navbar-dark bg-falcon-white" style={{ borderBottom: "1px solid #d8e2ef" }}>
          <Link to={"/"} className="m-45">
            <img src="https://xeniapp-image-bucket-prod.s3.amazonaws.com/674cbf6cd3073d04f2145719-logo.png?1733938258735" alt="Savvy Logo" width={"226px"}  />
          </Link>

          {currentUser ? (
            <div className="navbar-nav ml-auto">
              <li className="nav-item">
                <Link to={"/membership"} className="nav-link">
                  {currentUser.username}
                </Link>
              </li>
              <li className="nav-item">
                <div className={`position-static position-md-relative dropdown ${isDropdownOpen ? 'show' : ''}`} ref={this.dropdownRef}>
                  <button
                      type="button"
                      id="profile-dropdown"
                      aria-expanded={isDropdownOpen}
                      className={`px-0 profile-toggle d-flex toggle border-0 ${isDropdownOpen ? 'show' : ''}`}
                      onClick={this.toggleDropdown}
                  >
                    <div className="avatar avatar-xl">
                      <div className="avatar-name rounded-circle avatar-user">
                        <span>{this.getInitials(currentUser.user.data.firstName, currentUser.user.data.lastName)}</span>
                      </div>
                    </div>
                  </button>
                  {isDropdownOpen && (
                      <div
                          className="z-1500 mt-md-0 dropdown-menu show"
                          data-popper-reference-hidden="false"
                          data-popper-escaped="false"
                          data-popper-placement="bottom-end"
                          style={{
                            position: 'absolute',
                            inset: '0px 0px auto auto',
                            transform: 'translate3d(-20px, 60px, 0px)',
                          }}
                      >
                        <div className="rounded-2">
                          <a className="dropdown-item" href="/membership">
                            <div className="d-flex align-items-center">
                              <div className="avatar avatar-m">
                                <div className="avatar-name rounded-circle avatar-user" style={{ fontSize: ".5rem" }}>
                                  <span>{this.getInitials(currentUser.user.data.firstName, currentUser.user.data.lastName)}</span>
                                </div>
                              </div>
                              <span className="ps-2 flex-grow-1 fs--1 text-900" style={{ fontSize: "14px", paddingLeft: "5px" }}> {currentUser.user.data.firstName} {currentUser.user.data.lastName}</span>
                            </div>
                          </a>
                          <hr className="dropdown-divider" role="separator"/>
                          <a className="dropdown-item" href={`https://members.savvywholesaletravel.com/sso?token=${currentUser.access_token}`}>
                            <div className="d-flex  align-items-center"><span className="d-flex justify-content-center"
                                                                              style={{width: '16px'}}><svg
                                aria-hidden="true" focusable="false" data-prefix="fas" data-icon="hand-point-right"
                                className="svg-inline--fa fa-hand-point-right fa-w-16 d-flex  align-items-center"
                                role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path
                                fill="currentColor"
                                d="M512 199.652c0 23.625-20.65 43.826-44.8 43.826h-99.851c16.34 17.048 18.346 49.766-6.299 70.944 14.288 22.829 2.147 53.017-16.45 62.315C353.574 425.878 322.654 448 272 448c-2.746 0-13.276-.203-16-.195-61.971.168-76.894-31.065-123.731-38.315C120.596 407.683 112 397.599 112 385.786V214.261l.002-.001c.011-18.366 10.607-35.889 28.464-43.845 28.886-12.994 95.413-49.038 107.534-77.323 7.797-18.194 21.384-29.084 40-29.092 34.222-.014 57.752 35.098 44.119 66.908-3.583 8.359-8.312 16.67-14.153 24.918H467.2c23.45 0 44.8 20.543 44.8 43.826zM96 200v192c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24h48c13.255 0 24 10.745 24 24zM68 368c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"></path></svg></span><span
                                className="ps-3 flex-grow-1 px-1">Book Now</span></div>
                          </a>
                          <a className="dropdown-item" href={`https://members.savvywholesaletravel.com/sso?token=${currentUser.access_token}&navigateTo=mytrip/mytrips`}>
                            <div className="d-flex  align-items-center"><span className="d-flex justify-content-center"
                                                                              style={{width: '16px'}}><svg
                                aria-hidden="true" focusable="false" data-prefix="far" data-icon="suitcase-rolling"
                                className="svg-inline--fa fa-suitcase-rolling fa-w-12 d-flex  align-items-center"
                                role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path
                                fill="currentColor"
                                d="M336 128h-48V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v80H48c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h16v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h128v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h16c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zM144 48h96v80h-96V48zm192 384H48V176h288v256zm-232-48h176c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8H104c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8zm0-112h176c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8H104c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8z"></path></svg></span><span
                                className="ps-3 flex-grow-1 px-1">My Trips</span></div>
                          </a>
                          <a className="dropdown-item" href="/membership">
                            <div className="d-flex align-items-center">
                <span className="d-flex justify-content-center" style={{width: '24px'}}>
                  <i className="fas fa-user"></i>
                </span>
                              <span className="ps-3 flex-grow-1">Manage Membership</span>
                            </div>
                          </a>

                          <hr className="dropdown-divider" role="separator"/>
                          <a className="dropdown-item" href="#" onClick={this.logOut}>
                            <div className="d-flex align-items-center">
                <span className="d-flex justify-content-center" style={{width: '24px'}}>
                  <i className="fas fa-sign-out-alt text-danger"></i>
                </span>
                              <span className="ps-3 flex-grow-1 text-danger">Log Out</span>
                            </div>
                          </a>
                        </div>
                      </div>
                  )}
                </div>
              </li>
            </div>
          ) : (
              <div className="navbar-nav ml-auto">
                <li className="nav-item" >
                  <Link to={"/login"} className="nav-link">
                    <span style={{ color: '#000000' }}>Login</span>
                  </Link>
                </li>

                <li className="nav-item">
                  <Link to={"/register"} className="nav-link">
                     <span style={{ color: '#000000' }}>Sign Up</span>
                  </Link>
                </li>
              </div>
          )}
        </nav>

        <div className="container mt-3" style={{ paddingTop: "1rem" }}>
          <Routes>
            <Route path="/" element={<Home/>}/>
            <Route path="/home" element={<Home/>}/>
            <Route path="/login" element={<Login/>}/>
            <Route path="/register" element={<Register/>}/>
            <Route path="/forgot-password" element={<ForgotPassword/>}/>
            <Route path="/reset-password" element={<ResetPassword/>}/>
            <Route path="/membership" element={<Profile/>}/>
            <Route path="/user" element={<BoardUser/>}/>
            <Route path="/mod" element={<BoardModerator/>}/>
            <Route path="/admin" element={<BoardAdmin/>}/>
          </Routes>
        </div>

        {/* <AuthVerify logOut={this.logOut}/> */}
      </div>
    );
  }
}

export default App;
